<template>
  <section>
    <!-- TODO: To fix the grid reorderable, temporarly disabled. -->
    <Grid
        :pageable="pageable"
        :resizable="isResizable"
        :reorderable="false"
        :sortable="isSortable"
        :row-height="25"
        selected-field="selected"
        :data-items="itemData"
        :page-size="pageSizes"
        :total="totalItems"
        :take="take"
        :skip="skip"
        :columns="currentColumns"
        :sort="sortDetails"
        @pagechange="handlePageChange"
        @columnresize="handleColumnResize"
        @rowclick="handleRowClick"
        @sortchange="handleSortChange"
        @columnreorder="handleColumnReorder"
        :class="styleCustom == '' ? 'grid' : ''"
        :style="styleCustom"
        >
        <!-- puts the gear icon in the header -->
        <template v-slot:commandsHeader="{}" >
          <div class="d-flex justify-content-center">
            <i @click="onClickGridSettings" class="open-grid-settings-popover fa fa-cog fa-fw"></i>
          </div>
        </template>
        <!-- puts the checkbox icon in the header -->
        <template v-slot:selectCommandsHeader="{}" >
          <div class="d-flex justify-content-center align-items-center">
            <input type="checkbox" v-model="checkAllRows" v-if="!hideCheckBoxAction" />
          </div>
        </template>
        <!-- puts the details icon in the header -->
        <template v-slot:detailCommandsHeader="{}" >
          <div class="d-flex justify-content-center align-items-center">
            <i class="fa fa-icon"></i>
          </div>
        </template>
        <!-- makes the navigation field -->
        <template v-slot:navigation="{props}">
          <td>
            <div class="d-flex" v-if="canEdit">
              <a class="grid-link" @click="onEdit(props.dataItem)">{{ props.dataItem[props.field] }}</a>
            </div>
            <div class="d-flex" v-if="!canEdit">
              {{ props.dataItem[props.field] }}
            </div>
          </td>
        </template>
        <!-- makes the multipleNavigation field -->
        <template v-slot:multipleNavigation="{props}">
          <td>
            <div class="d-flex" v-if="canEdit">
              <a class="grid-link" @click="onNavigation(props.dataItem,props.field)">{{ props.dataItem[props.field] }}</a>
            </div>
            <div class="d-flex" v-if="!canEdit">
              {{ props.dataItem[props.field] }}
            </div>
          </td>
        </template>
        <!-- makes the dynamicNavigation field -->
        <template v-slot:dynamicNavigation="{props}">
          <td>
            <div class="d-flex" v-if="dynamicValToLink != null && props.dataItem[props.field] == dynamicValToLink">
              <a class="grid-link" @click="onDynamicNav(props.dataItem)">{{ props.dataItem[props.field] }}</a>
            </div>
            <div class="d-flex" v-else>
              {{ props.dataItem[props.field] }}
            </div>
          </td>
        </template>
        <!-- puts the checkbox for each row -->
        <template v-slot:selectcommands="{props}">
          <td>
            <div class="d-flex justify-content-center align-items-center" >
              <input type="checkbox" :value="props.dataItem.id" v-model="checkedArray" v-if="!hideCheckBoxAction" />
            </div>
          </td>
        </template>
        <!-- puts the more detail icon for each row -->
        <template v-slot:detailcommands="{props}">
          <td>
            <div class="d-flex justify-content-center align-items-center" v-if="detailsReference != null && props.dataItem[detailsReference]">
              <i @click="onDetail(props.dataItem)" class="fa fa-info" v-if="!detailsLabel"></i>
              <b-button variant="info" @click="onDetail(props.dataItem)" style="font-size: 80%" size="sm" v-else>{{ detailsLabel }}</b-button>
            </div>
          </td>
        </template>
        <!-- puts the delete icon for each row -->
        <template v-slot:deletecommands="{props}">
          <td>
            <div class="d-flex justify-content-center align-items-center" v-if="canDelete">
              <i @click="onDelete(props.dataItem)" class="fa fa-times table-action-icon-delete" :disabled="disablesDelete"></i>
            </div>
          </td>
        </template>
        <!-- formats the number -->
        <template v-slot:formatSeparator="{props}">
          <!-- <td>{{ (props.dataItem[props.field]) ? props.dataItem[props.field].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0 }}</td> -->
          <td>{{ commafy(props.dataItem[props.field]) }}</td>
        </template>
        <!-- formats the date -->
        <template v-slot:formatDate="{props}">
          <td>{{ date(props.dataItem[props.field]) }}</td>
        </template>
        <!-- formats the currency converted into 2 precision -->
        <template v-slot:formatCurrencyConverted="{props}">
          <!-- <td>{{ Number(props.dataItem[props.field]).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td> -->
          <td>{{ commafy(props.dataItem[props.field], "$", 2) }}</td>
        </template>
        <!-- formats the currency with symbol and precision of 2 -->
        <template v-slot:formatCurrency="{props}">
          <!-- <td>{{ ((props.dataItem['currencySymbol'] != undefined || props.dataItem['currencySymbol'] != null) ? props.dataItem['currencySymbol'] : '')
                + Number(props.dataItem[props.field]).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td> -->
          <td>{{ commafy(props.dataItem[props.field], props.dataItem['currencySymbol'], 2 ) }}</td>
        </template>
        <!-- formats the currency converted into 4 precision -->
        <template v-slot:formatAmountConverted="{props}">
          <!-- <td>{{ Number(props.dataItem[props.field]).toLocaleString('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 4 }).replace(/\B(?=(\d{3})+(?!\d))/g, ",") }}</td> -->
          <td>{{ commafy(props.dataItem[props.field], "$", 4) }}</td>
        </template>
        <!-- formats the amount with symbol and precision of 4 -->
        <template v-slot:formatAmount="{props}">
          <!-- <td>{{ ((props.dataItem['currencySymbol'] != undefined || props.dataItem['currencySymbol'] != null) ? props.dataItem['currencySymbol'] : '')
                + Number(props.dataItem[props.field]).toFixed(4) }}</td> -->
          <td>{{ commafy(props.dataItem[props.field], props.dataItem['currencySymbol'], 4 ) }}</td>
        </template>
        <!-- formats the amount with symbol and precision of 4 -->
        <template v-slot:formatCurrencyPrice="{props}">
          <!-- <td>{{ ((props.dataItem['currencySymbol'] != undefined || props.dataItem['currencySymbol'] != null) ? props.dataItem['currencySymbol'] : '')
                + Number(props.dataItem[props.field]).toFixed(4) }}</td> -->
          <td>{{ commafy(props.dataItem[props.field], props.dataItem['targetPriceSymbol'], 4 ) }}</td>
        </template>
        <!-- formats the percentage -->
        <template v-slot:formatPercentage="{props}">
          <td>{{ props.dataItem[props.field] }}%</td>
        </template>
        <!-- formats the link -->
        <template v-slot:formatLink="{props}">
          <td>
            <a class="grid-link" target="_blank" :href="formatUrl(props.dataItem[props.field])" >{{ props.dataItem[props.field] }}</a>
          </td>
        </template>
        <!-- formats as star rating -->
        <template v-slot:formatRating="{props}">
          <td>
            <star-rating :star-size="10" :increment="0.5" :read-only="true" :show-rating="false" v-model="props.dataItem[props.field]"></star-rating>
          </td>
        </template>
        <!-- formats rating as word -->
        <template v-slot:formatRatingAsWord="{props}">
          <td v-if="props.dataItem[props.field]"> {{ props.dataItem[props.field] }}/5 </td>
          <td v-else>No Rating</td>
        </template>
        <!-- if this column has value == true -->
        <template v-slot:checkMark="{props}">
          <td>
            <div v-if="props.dataItem[props.field]" class="d-flex justify-content-center align-items-center">
              &check;
            </div>
          </td>
        </template>
         <!-- if this column has value == false -->
        <template v-slot:invertedCheckMark="{props}">
          <td>
            <div v-if="!props.dataItem[props.field]" class="d-flex justify-content-center align-items-center">
              &check;
            </div>
          </td>
        </template>
        <!-- format a text field as type number in the grid -->
        <template v-slot:formatNumberField="{props}">
            <td>
                <div class="d-flex justify-content-center align-items-center">
                    <b-form-input type="number" min="0" v-model="props.dataItem[props.field]" @input="onChange(props.field, props.dataItem[props.field], props.dataItem.id)" />
                </div>
            </td>
        </template>
        <!-- format a text field as type text in the grid -->
        <template v-slot:formatTextField="{props}">
            <td>
                <div class="d-flex justify-content-center align-items-center">
                    <b-form-input v-model="props.dataItem[props.field]" />
                </div>
            </td>
        </template>
        <!-- format a select field as type text in the grid -->
        <template v-slot:formatOptionsField="{props}">
            <td>
                <div class="d-flex justify-content-center align-items-center">
                    <b-form-select v-model="props.dataItem[props.field]" >
                        <option v-for="option in sortSelect(optionsField)" :key="option.name" :value="option.id">
                            {{ option.name }}</option>
                    </b-form-select>
                </div>
            </td>
        </template>
      <!-- formats as yes/no/blankselection rating -->
        <template v-slot:formatBooleanForNull="{props}">
          <td v-if="props.dataItem[props.field]">Yes</td>
           <td v-else-if="!props.dataItem[props.field]">No</td>
          <td v-else>No Selection</td>
        </template>
         <!-- formats as yes/no rating -->
        <template v-slot:formatBoolean="{props}">
         <td v-if="props.dataItem[props.field]">Yes</td>
           <td v-else>No</td>      
        </template>

        <!-- mail to the link -->
        <template v-slot:mailToEmail="{props}">
          <td>
            <a class="grid-link" :href="`mailto:${props.dataItem[props.field]}`" >{{ props.dataItem[props.field] }}</a>
          </td>
        </template>

        <grid-norecords>
          <div class="k-loading-mask customPosition" style="top:50px" v-if="isTblLoader"><span class='k-loading-text'></span><div class='k-loading-image'/>
            <div class='k-loading-color'/>
          </div>
          <div v-else>No records available</div>
        </grid-norecords>
      </Grid>
      <grid-settings ref="gridSettingsComponent" :gridId="gridId" :currentFields="currentColumns" :defaultFields="fields" :settingsName="gridSettingsName" />
        <!-- @resetColumn="getColumns" /> -->
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { sortChange, prepareColumnsData } from '@/shared/helpers';
import { SEARCH_DEBOUNCE_TIME, SAVE_SETTINGS_DELAY, DEFAULT_SORT_ORDER } from '@/shared/constants';
import GridSettings from '@/shared/components/GridSettings';
import debounce from 'lodash/debounce';
import { date } from '@/shared/filters';
import StarRating from 'vue-star-rating';

export default {
  components: {
    GridSettings,
    StarRating,
  },
  props: {
    gridId: [String],
    isResizable: [Boolean],
    isReorderable: [Boolean],
    isSortable: [Boolean],
    pageSizes: [Number],
    totalItems: [Number],
    navigationField: {
      type: String,
      default: 'id',
    },
    itemData: {
      type: Array,
      default: () => [],
    },
    fields: {
      type: Array,
      default: () => [],
    },
    skip: {
      type: Number,
      default: 0,
    },
    take: {
      type: Number,
      default: 10,
    },
    pageable: {
      type: Object,
      default: () => {},
    },
    sortBy: {
      type: String,
      default: null,
    },
    sortOrder: {
      type: String,
      default: null,
    },
    checkBoxValues: {
      type: Array,
      default: () => [],
    },
    sortMethod: [Function],
    onEdit: {
      type: Function,
      default: () => {},
    },
    onNavigation: {
      type: Function,
      default: () => {},
    },
    onDelete: {
      type: Function,
      default: () => {},
    },
    onDetail: {
      type: Function,
      default: () => {},
    },
    handleRowClick: {
      type: Function,
      default: () => {},
    },
    styleCustom: {
      type: String,
      default: '',
    },
    disablesEdit: {
      type: Boolean,
      default: false,
    },
    disablesDelete: {
      type: Boolean,
      default: false,
    },
    detailsReference: {
      type: String,
      default: null
    },
    hideCheckBoxAction: {
      type: Boolean,
      default: false,
    },
    optionsField: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    debug: {
      type: Boolean,
      default: false,
    },
    autoCheckBy: {
      type: String,
      default: null,
    },
    isTblLoader: {
      type: Boolean,
      default: false,
    },
    detailsLabel: {
      type: String,
      default: null
    },
    dynamicValToLink: {
      type: String,
      default: null
    },
    onDynamicNav: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      date,
      prepareColumnsData,
      checkedArray: [],
      oldSort: {}
    }
  },
  computed: {
    ...mapGetters('account', ['gridSettingsById']),
    ...mapGetters('lookup', ['currencies']),
    gridSettings() {
      let data= this.gridSettingsById(this.gridId);
      return data;
    },

    gridSettingsName(){
      return this.gridId + '-settings-trigger'; //used to uniquely define the settings target for the grid
    },
    sortDetails: function () {
      if (this.sortBy) {
        return [{ field: this.sortBy, dir: (this.sortOrder) ? this.sortOrder.toLowerCase():DEFAULT_SORT_ORDER.toLowerCase() }];
      }

      if (this.gridSettings.sort) {
        return [{ field: this.gridSettings.sort.sortBy, dir: this.gridSettings.sort.sortOrder.toLowerCase() }];
      }

      return [];
    },
    checkAllRows: {
      get() {
        return this.itemData && this.itemData.length > 0 ? this.checkedArray.length === this.itemData.length : false;
      },
      set(value) {
        let checked = [];

        if (value) {
          this.itemData.forEach((item) => {
            checked.push(item.id)
          });
        }

        this.checkedArray = checked;
      },
    },
    currentColumns() {
      return (this.gridSettings.columns != undefined && this.gridSettings.columns.length > 0) ? this.gridSettings.columns : this.fields;
    }
  },
  methods: {
    ...mapActions('account', ['saveGridSettings']),
    handlePageChange(event) {
      this.$emit('getData', {
        ...this.gridSettings.sort,
        pageSize: event.page.take,
        pageNumber: Math.floor(event.page.skip / event.page.take) + 1,
      });
    },
    handleColumnResize: debounce(function ({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: this.currentColumns,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({ id: this.gridId, settings: { columns: newColumns } });
    }, SAVE_SETTINGS_DELAY),
    handleColumnReorder({ columns }) {
      const newColumns = prepareColumnsData({
        columns,
        initialColumns: this.currentColumns,
        settingsColumns: this.gridSettings.columns,
      });

      this.saveGridSettings({ id: this.gridId, settings: { columns: newColumns } });
    },
    handleSortChange({ sort }) {
      if (sort.length) {
        this.oldSort[this.gridId] = sort;
      } else if (this.oldSort[this.gridId]) {
        sort = this.oldSort[this.gridId];
        sort[0].dir = sort[0].dir == 'asc' ? 'desc' : 'asc';
      }
      sortChange({
        sort: this.sortMethod,
        sortData: sort,
        gridId: this.gridId,
        saveGridSettings: this.saveGridSettings,
      });
    },
    formatUrl: function(url){
      if(url != null && !url.startsWith('http://')){
        url = 'http://' + url;
      }
      return url;
    },
    onClickGridSettings() {
      this.$refs.gridSettingsComponent.getCopyColumn();
    },
    commafy(num, currency = "", decimal = 2) {
      try {
        if (num != null) {
          if (currency != "") {
            num = Number(num).toFixed(decimal);
          }
          var str = num.toString().split('.');
          if (str[0].length >= 3) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
          }
          if (str[1]) {
            if (str[1].length < decimal) {
              while (str[1].length < decimal) { str[1] = str[1] + "0"; }
            } else if (str[1].length > decimal) {
              str[1] = str[1].substring(0, decimal)
            }
          }
          return currency + str.join('.');
        }
      } catch {
        return num;
      }
    },
    onChange(col, val, id) {
      if (this.autoCheckBy == col) {
        const ndx = this.itemData.findIndex(x => x.id == id);
        if (ndx > -1) {
          const checkedNdx = this.checkedArray.findIndex(num => num == id);
          const isCheck = Boolean(val);

          if (this.itemData[ndx].selected != undefined) {
            this.itemData[ndx].selected = isCheck;
          }

          if (isCheck && checkedNdx == -1) {
            this.checkedArray.push(id);
          } else if (!isCheck && checkedNdx > -1) {
            this.checkedArray.splice(checkedNdx, 1);
          }
        }
      }
    }
  },
  watch: {
    checkedArray() {
      this.$emit('checkedItem', this.checkedArray)
    },
    checkBoxValues() {
      this.checkedArray = this.checkBoxValues;
    },
    take(pageSize) {
      this.saveGridSettings({
        id: this.gridId,
        settings: {
          ...this.gridSettings,
          pageSize,
        },
      });
    },
  },
  mounted() {
    /*if(this.debug){
    console.log('grid mounted',this.take,this.skip);
    }*/
  }
}
</script>

<style>
.open-grid-settings-popover, .close-grid-settings-popover {
   cursor: pointer;
 }

.open-grid-settings-popover:hover, .close-grid-settings-popover:hover {
  opacity: 0.7;
}
</style>
